export default __webpack_public_path__ + "static/media/logoExtended.2a3a0d95.png";